import { EnvironmentInjector, InjectionToken, Provider, createEnvironmentInjector } from '@angular/core';
import { HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';

export const SSE_HTTP_CLIENT = new InjectionToken<HttpClient>('SSE_HTTP_CLIENT');

export const provideSseHttpClient = (): Provider => ({
  provide: SSE_HTTP_CLIENT,
  useFactory: (parent: EnvironmentInjector): HttpClient => {
    const child = createEnvironmentInjector([provideHttpClient(withFetch(), withInterceptorsFromDi())], parent);
    return child.get(HttpClient);
  },
  deps: [EnvironmentInjector],
});
